import React from 'react'
import { View, ViewStyle } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@components/base'
import { Slider, SliderProps } from '../Slider'

interface SliderInputBlockProps extends SliderProps {
  label: string
  value: number
  min?: number
  max?: number
  step?: number
  rightAccessoryText?: string
  onValueChanged: (value: number) => void
  showValue?: boolean
  style?: ViewStyle
}

export const SliderInputBlock = (props: SliderInputBlockProps) => {
  const styles = useStyleSheet(themedStyle)
  const {
    label,
    value,
    min = 1,
    max = 10,
    step = 1,
    showValue = true,
    rightAccessoryText,
    onValueChanged,
    style,
    ...sliderProps
  } = props

  const onValuesChange = (values: number[]) => {
    onValueChanged(values[0])
  }

  return (
    <View style={style}>
      <View style={styles.header}>
        <Text type="regular">{label}</Text>
        {showValue && !rightAccessoryText && (
          <Text type="large" bold>
            {value}
          </Text>
        )}
        {!showValue && rightAccessoryText && <Text type="large">{rightAccessoryText}</Text>}
      </View>
      <Slider
        min={min}
        max={max}
        step={step}
        values={[value]}
        onValuesChange={onValuesChange}
        {...sliderProps}
      />
    </View>
  )
}

const themedStyle = StyleService.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
})
